<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label required">
          {{ $t('pickupCardActivator.guardianName') }}
        </label>
        <ts-loading-banner :loading="loadingPreData">
          <ts-select-guardian v-model.number="model.student_pickup_id" />
        </ts-loading-banner>
        <div class="validate" v-if="errors.has('student_pickup_id')">
          {{ errors.first('student_pickup_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">
          {{ $t('pickupCardActivator.serialCard') }}
        </label>
        <input
          v-model="model.serial_card"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('serial_card') }"
        />
        <div class="invalid-feedback" v-if="errors.has('serial_card')">
          {{ errors.first('serial_card') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          >{{ $t('save') }}</ts-button
        >
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import FormComponent from './confirm-deactivate-old-card.vue'
import TsSelectGuardian from '@/components/SelectGuardian'

export default {
  name: 'student-card-activator-form',
  components: { TsSelectGuardian },
  data() {
    return {
      model: {
        student_pickup_id: null,
        serial_card: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false,
      loadingPreData: false
    }
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'student-card-activator' })
    },

    async checkStudentCardStatus(data) {
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'pickupCardActivator/checkCurrentStudentCardStatus',
          data
        )
        if (response.status == true) {
          this.saving = false
          this.showForm(data)
        }

        return response.status
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
    },

    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      this.check = await this.checkStudentCardStatus(this.model)
      if (this.check == false) {
        try {
          let response = await this.$store.dispatch(
            'pickupCardActivator/create',
            this.model
          )
          this.$toasted.success(response.message)
          this.$emit('success_create')
          this.clearForm()
        } catch (error) {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        }
        this.saving = false
      }
      this.saving = false
    },

    clearForm() {
      this.model = {
        student_pickup_id: '',
        serial_card: ''
      }
    }
  }
}
</script>
